// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"377":"chat","545":"language","822":"disclaimer"}[chunkId] + "." + {"377":"b161590b","545":"60b23dff","822":"a990682f"}[chunkId] + ".js";
};